import styles from './index.module.less';

export const BaseDivider = () => {
	return <div className={styles.divider}></div>;
};
